import { AccessBase } from '../access/BaseAccess';
import { VariableProperties } from '../datatype/VariablePropertiesDomains';
import { DeploymentStatus, CraType } from '../../constant/Constants';
import { Syntax } from '@trlogic/ui-pack';
import { ApiVariableParameter } from '../enrichment/EnrichmentDomain';
import { ResponseFormats } from 'constant/ResponseFormats';
import { WatchlistListsModel } from '../watchlist/WatchlistDomains';

export interface CraSchema {
  id: string;
  stage: string;
  schema: {
    name: string;
    variables: Array<
      | {
          type: 'STRING' | 'NUMBER' | 'DATE';
          name: string;
          weight: number;
        }
      | {
          type: 'API';
          name: string;
          weight: number;
          method: string;
          urlExpression: string;
          bodyExpression: string;
          headerExpressions: Record<string, string>;
          responseExpression: string;
          timeout: number;
        }
      | {
          type: 'WATCHLIST';
          name: string;
          weight: number;
          watchlistType: string;
          lists: string[];
        }
    >;
  };
}

export interface PolicyJsonModel extends AccessBase {
  name: string;
  assessor: CraType;
  description: string;
  version: string;
  stage: DeploymentStatus;
  variables: Array<CraVariableSchema>;
  status: boolean;
}

export interface CraVariableSchema {
  name: string;
  type: CraSegmentType;
  isEnabled: boolean;
  weight: number;
  description?: string;
  url?: string;
  method?: string;
  parameters?: ApiVariableParameter[];
  headers?: Record<string, { value: string; description: string }>;
  body?: string | null;
  auth?: string;
  mapping?: Syntax;
  responseType?: ResponseFormats;
  timeout?: number;
  properties?: VariableProperties;
  watchlistType?: WatchlistType;
  lists?: string[];
}

export interface CraStringSegmentsSchema {
  id: string;
  assessor: string;
  variable: string;
  value: string;
  score: number;
}

export interface CraNumberSegmentsSchema {
  id: string;
  assessor: string;
  variable: string;
  score: number;
  from: number;
  to: number;
}

export interface CraDateSegmentsSchema {
  id: string;
  assessor: string;
  variable: string;
  score: number;
  from: number;
  to: string;
}

export enum CraSegmentType {
  STRING = 'String',
  NUMBER = 'Number',
  DATE = 'Date',
  WATCHLIST = 'Watchlist',
  API = 'API',
}

export enum WatchlistType {
  GENERAL = 'GENERAL',
  INDIVIDUAL = 'INDIVIDUAL',
  ENTITY = 'ENTITY',
}

export interface PolicySchema {
  name: string;
  version: string;
  rowTimeField?: string;
  keyField: string;
  columns: PolicyColumnSchema[];
  from: string;
  where: string;
}

export interface PolicyColumnSchema {
  name: string;
  properties: VariableProperties;
  expression?: string | undefined;
}

export interface PolicyColumnJsonModel {
  name: string;
  properties: VariableProperties;
  expression?: Syntax;
}

export interface WatchlistListsEditorModel extends WatchlistListsModel {
  isEnabled: boolean;
}

export interface CraDetailedScore {
  score: number;
  value: string;
  variable: string;
}

export interface CraAssessmentResult {
  id: string;
  score: number;
  assessor: string;
  assessee?: string;
  createdAt?: number;
  lastUpdatedAt?: number;
  detailedScores?: CraDetailedScore[];
}

export interface CraApiVariableSchema {
  url: string;
  method?: string;
  parameters?: ApiVariableParameter[];
  headers?: Record<string, { value: string; description: string }>;
  body?: string | null;
  auth?: string;
  mapping?: any;
  responseType: ResponseFormats;
  timeout: number;
  properties?: any;
}
